export default __webpack_public_path__ + "static/media/menu-06-more-w.a6651d0d.svg";